export default __webpack_public_path__ + "f6f9e7581358e65ab7f2b4c2a8821141.svg";